import CompLayout from "@/pcomponents/comp/layout/layout";
import CoreListShareArea from "@/pages/comp/plan/video/acommon/corse_share/list";


function ListPage(){
  return (
    <CompLayout>
      <CoreListShareArea></CoreListShareArea>
    </CompLayout>
  );
}

export default ListPage;